/**
 * Frontend-Compatible User Tracking Storage Module
 * This module provides a browser-compatible interface for user tracking
 * that communicates with the backend server for data storage.
 */

/**
 * Save user tracking event via API call to backend
 * @param {Object} eventData - The tracking event data
 */
export async function saveUserTrackingEvent(eventData) {
  try {
    const response = await fetch('http://localhost:5000/api/tracking/save-event', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('✅ Event saved to Big Data Cloud:', eventData.eventType);
    return result;
  } catch (error) {
    console.error('❌ Error saving event to Big Data Cloud:', error);
    throw error;
  }
}

/**
 * Get user analytics from backend
 * @param {string} userId - The user ID to get analytics for
 */
export async function getUserAnalytics(userId) {
  try {
    const response = await fetch(`http://localhost:5000/api/tracking/analytics/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error getting user analytics:', error);
    return { userId, error: 'Failed to get analytics' };
  }
}

/**
 * Get contact interactions from backend
 */
export async function getContactInteractions() {
  try {
    const response = await fetch('http://localhost:5000/api/tracking/contacts', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('❌ Error getting contact interactions:', error);
    return [];
  }
}

/**
 * Mark contact as processed
 * @param {string} eventId - The event ID to mark as processed
 */
export async function markContactAsProcessed(eventId) {
  try {
    const response = await fetch(`http://localhost:5000/api/tracking/contact/${eventId}/processed`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.success || false;
  } catch (error) {
    console.error('❌ Error marking contact as processed:', error);
    return false;
  }
}

console.log('🌐 Frontend User Tracking Module initialized');